import axios from "axios"
class bridge {
    post(endpoint,query) {
        let qry = {"method":"get","url":endpoint,"data":query}
        return axios.post(process.env.VUE_APP_BRIDGE_API + "bridge/"+window.licenceid,qry,{headers:{Authorization:process.env.VUE_APP_AUTH_TOKEN_BR}})
    }
}
class direct {
    post(endpoint,data) {
        return axios.post(window.serverInfoGG+endpoint,data,{headers:{Authorization:process.env.VUE_APP_AUTH_TOKEN_GG}})
    }
}
export default {
    post(endpoint,query) {
        let con
        switch(window.datasource) {
            case "BR":
                con = new bridge()
                return con.post(endpoint,query)
            case "GG":
                con = new direct()
                return con.post(endpoint,query)
        }
    }
}